import React from "react";
import { Route, Redirect, useRouteMatch } from "react-router-dom";
import CacheRoute, { CacheSwitch } from "react-router-cache-route";
import MainOrderList from "./mainOrderList";
import SubOrderList from "./subOrderList";
import OrderDetail from "./detail";
import SignatureAgreement from "./signatureAgreement";
import OrderDetailPreview from "./preview";

export default function MobileService() {
  const { path } = useRouteMatch();
  //   <CacheSwitch>
  //   <Route
  //     exact
  //     path={`${path}`}
  //     render={() => <Redirect to={`${path}/list`}></Redirect>}
  //   ></Route>
  //   <CacheRoute path={`${path}/list`}>
  //     <OrderList />
  //   </CacheRoute>
  //   <Route path={`${path}/detail/:orderId`}>
  //     <OrderDetail />
  //   </Route>
  //   <Route path={`${path}/preview`}>
  //     <OrderDetailPreview />
  //   </Route>
  // </CacheSwitch>
  return (
    <CacheSwitch>
      <Route
        exact
        path={`${path}`}
        render={() => <Redirect to={`${path}/mainOrderList`}></Redirect>}
      ></Route>
      <Route
        exact
        path={`${path}/list`}
        render={() => <Redirect to={`${path}/mainOrderList`}></Redirect>}
      >
      </Route>
      <Route
        exact
        path={`${path}/detail/:orderId`}
        render={(props) => {
          console.log("旧路由的id", props.match.params.orderId);
          return (
            <Redirect
              to={`${path}/orderDetail/reserveDetailV2?reserveId=${props.match.params.orderId}`}
            ></Redirect>
          );
        }}
      ></Route>
      <CacheRoute path={`${path}/mainOrderList`}>
        <MainOrderList />
      </CacheRoute>
      <Route path={`${path}/subOrderList`}>
        <SubOrderList />
      </Route>
      <Route path={`${path}/orderDetail`}>
        <OrderDetail />
      </Route>
      <Route path={`${path}/signatureAgreement`}>
        <SignatureAgreement />
      </Route>
      {/* 图片预览页 */}
      <Route path={`${path}/preview`}>
        <OrderDetailPreview />
      </Route>
    </CacheSwitch>
  );
}
